import {useTranslation} from "react-i18next";
import React, {useEffect, useRef, useState} from "react";
import {Button, Card, Col, Row} from "reactstrap";
import SortableList from "../../Common/Components/Lists/SortableList";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {ADMIN_PATHS} from "../../config";
import {useNavigate} from "react-router-dom";
import AdminResponseOpenPaymentModel from "../Models/Response/AdminResponseOpenPaymentModel";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import { CustomModal } from "../../Common/Components/Modal/CustomModal";
import { ChangeDateFormat } from "../../Common/Helpers/ChangeDateFormat";
import { FlashMessage } from "../../Common/Helpers/FlashMessage";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";
import $ from 'jquery';
import { ReimbursementTypeBadges, getUnionReimbursementTypes } from "../../Common/Components/Badges/ReimbursementTypeBadges";

export function BankTransferHistoryList ({ isReadOnly = false, setActiveTab = null }) {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const isMobile = CheckMobile(998);

    //RESPONSE SEARCH
    let idFromUrl = '';
    if (window.location.pathname.includes('admin/user-list/user')) {
        idFromUrl = new URLSearchParams(window.location.search).get('id');
    }

    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('openPayment.historyBankList'));
        setPageTitleKey('openPayment.historyBankList');
        setOnBack(isReadOnly ? () => navigate(ADMIN_PATHS.BANK_TRANSFERS_LIST) : null);
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    const [responseOpenPaymentList, setResponseOpenPaymentList] = useState('');

    const [showPaymentDetails, setShowPaymentDetails] = useState(false);
    const [paymentDetailsList, setPaymentDetailsList] = useState([]);
    const [paymentId, setPaymentId] = useState('');
    const [titlePaymentDetails, setTitlePaymentDetails] = useState('');

    const idToShowPaymentDetails = new URLSearchParams(window.location.search).get('paymentId');
    // The list answers more than once while it loads, so the payment in the URL is
    // opened only the first time; otherwise a later answer reopens it after Avbryt.
    const paymentFromUrlOpened = useRef(false);

    useEffect(() => {
        if (!paymentFromUrlOpened.current && idToShowPaymentDetails !== null && responseOpenPaymentList?.items?.length > 0) {
            const foundItem = responseOpenPaymentList.items.find(
                (item) => item.id === idToShowPaymentDetails
            );
    
            if (foundItem) {
                paymentFromUrlOpened.current = true;
                setTitlePaymentDetails(foundItem.visualId + ' - ' + foundItem.creditorName);
                setPaymentDetailsList(foundItem.paymentDetails);
                setPaymentId(foundItem.id);                           
                setShowPaymentDetails(true);
            }
        }
    }, [responseOpenPaymentList]);
    
    // HANDLE MODAL WITH PAYMENT DETAILS
    // Manage browser back button to close modal
    useEffect(() => {
        if (showPaymentDetails) {
            window.history.pushState({ modalOpen: true }, '');
        }
        
        const handlePopState = (event) => {
            if (showPaymentDetails) {
                event.preventDefault();
                setShowPaymentDetails(false);
                let url = new URL(window.location.href);
                url.searchParams.delete('paymentId');
                window.history.replaceState({}, document.title, url.toString());
            }
        };
        
        window.addEventListener('popstate', handlePopState);
        
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [showPaymentDetails]);

    const renderActionColumn = (item) => {
        return (
            <>
            {item.paymentDetails  ?
                <button id={item.id} className="rounded me-2 py-2 border-0 text-green bg-green-light p-custom-button position-relative class-approve"
                            onClick={() => {
                                if(item.paymentDetails){
                                setPaymentDetailsList(item.paymentDetails);
                                setPaymentId(item.id);
                                setShowPaymentDetails(true); 
                                setTitlePaymentDetails(item.visualId + ' - ' + item.creditorName);
                            }else{
                                FlashMessage('Det är inte möjligt att se denna betalning, eftersom den tillhör den tidigare uppdateringen, för att se den gå till attesten eller direkt till roten av modellen t.ex: Ersättningsbegäran ,Årsarvode ,Betala Faktura etc...', 'flash-messageError');
                            }                           
                            }} >
                        {item.paymentDetails.length} <i className="bx bx-show pb-custom align-middle size-icon-custom-button" />
                        <div className="tooltip-custom-button">
                        {t('button.info')}
                        </div>
                 </button>   
                : 
                <button id={item.id} className="rounded me-2 py-2 border-0 text-green bg-green-light p-custom-button position-relative class-approve"
                        onClick={() => {
                            navigate(`${ADMIN_PATHS.BANK_TRANSFERS_INFO}?id=${item.id}`);
                        }} >
                    <i className="bx bx-show pb-custom align-middle size-icon-custom-button" />
                    <div className="tooltip-custom-button">
                        {t('button.info')}
                    </div>
                </button>
            } 
            </>   
        );
    }
    
    const columns = [ "visualId", 'creditorName','creditorAccountIban','updatedAt', 'status', 'instructedAmount'];
    const listOptions = {
        "model": AdminResponseOpenPaymentModel,
        'columns':[
            "visualId",'creditorName',
            {
                "field": "reimbursementTypes",
                "label": t('modelLabel.type'),
                "sortable": false,
                "value": (item) => <ReimbursementTypeBadges types={getUnionReimbursementTypes(item.paymentDetails)} center />
            },
            'creditorAccountIban','updatedAt', //añadir product, creditorAccountIban,instructedAmount
            {
                "field" : "status",
                "label" : t('modelLabel.status'),
                'insideClass' : (item)=> item.status === 'Betald' ?  'box-green' : 'box-red',
                "value": (item) => item.status === 'Betald' ? t('modelLabel.paidOut') :  item.status === 'Nekad' ? t('attest.denied') : item.status === 'Avbruten' ? t('honorarium.terminated') : t('modelLabel.unpaid') || "",
                'type': 'select' ,
            },
            {
                "field" : "instructedAmount",
                "label" : t('modelLabel.amount'),
                'insideClass' : (item)=> item.instructedAmount >= 0 ? 'text-green text-end fixed-width' : 'text-red text-end fixed-width', //w-75
                "value": (item) => item.instructedAmount ? ToCustomDecimal(item.instructedAmount) +' kr' : "",
                'thClass': 'ps-5',
                'type': 'number',
            }
        ],
        "actions": {
        "actionColumn" : renderActionColumn,
        },
        "exportIsAvailable": true,
        "filterTestIsAvailable": true,
        "urlGetListItemsToExport": "/open-payment/admin/search-paid/filter" + (idFromUrl ? `?id=${idFromUrl}` : ''),
        "nameFile": t('payReceive.bankAccount'),
        "modelType" : "BankTransferHistory",
        "ignoreFields" : columns,
        "urlGetSearch" : "/open-payment/admin/search-paid/filter",
        "viewName": "BankTransferHistoryList",
    };

    const headerPaymentDetails = (
        <div className="payment-details-header">
            <h4 className="fw-bold rokkitt-font">{titlePaymentDetails}</h4>
        </div>
    );

    const contentPaymentDetails = (
        <div className="payment-details-container text-start px-4" style={{ width: '100%', margin: '0 auto' }}>
            <div className="row fw-bold mb-2 border-bottom pb-2 align-items-center text-start">
                <div className="col-1 text-start">Id</div>
                <div className="col-3 text-nowrap text-start">
                    {t('modelLabel.type')}
                </div>
                <div className="col-2 text-start">{t('modelLabel.org')}</div>
                <div className="col-2 text-start">{t('modelLabel.attested')}</div>
                <div className="col-2 text-end">{t('modelLabel.amount')}</div>
                <div className="col-2 text-end"></div>
            </div>
            {paymentDetailsList.map((item, index) => {
                const renderReimbursementTypes = () => {
                    const types = item.reimbursementTypes || [];
                    if (types.length === 0) return null;

                    const hasA = types.includes('A');
                    const hasM = types.includes('M');
                    const hasU = types.includes('U');

                    return (
                        <div className="d-flex align-items-center justify-content-end ms-2" style={{ gap: '6px', minWidth: '84px' }}>
                            <div className="d-flex justify-content-center align-items-center" style={{ width: '24px', height: '24px' }}>
                                {hasA && (
                                    <span className="badge-amu-wrapper">
                                        <span className="fw-bold bg-green-light text-green d-flex align-items-center justify-content-center" style={{ width: '24px', height: '18px', fontSize: '12px', borderRadius: '6px', cursor: 'default' }}>A</span>
                                        <span className="badge-amu-tooltip">Arvode</span>
                                    </span>
                                )}
                            </div>
                            <div className="d-flex justify-content-center align-items-center" style={{ width: '24px', height: '24px' }}>
                                {hasM && (
                                    <span className="badge-amu-wrapper">
                                        <span className="fw-bold bg-green-light text-green d-flex align-items-center justify-content-center" style={{ width: '24px', height: '18px', fontSize: '12px', borderRadius: '6px', cursor: 'default' }}>B</span>
                                        <span className="badge-amu-tooltip">Bilersättning</span>
                                    </span>
                                )}
                            </div>
                            <div className="d-flex justify-content-center align-items-center" style={{ width: '24px', height: '24px' }}>
                                {hasU && (
                                    <span className="badge-amu-wrapper">
                                        <span className="fw-bold bg-green-light text-green d-flex align-items-center justify-content-center" style={{ width: '24px', height: '18px', fontSize: '12px', borderRadius: '6px', cursor: 'default' }}>U</span>
                                        <span className="badge-amu-tooltip">Utlägg</span>
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                };

                return (
                    <div className="row mb-2 align-items-center text-start" key={'payment-' + index}>
                        <div className="col-1 text-start">{item.visualId <= 0 ? 0 : item.visualId}</div>
                        
                        <div className="col-3 text-nowrap text-start">
                            {item.model === 'Förrättning' ? (
                                <div className="d-flex align-items-center justify-content-between w-100">
                                    <span>{t('reimbursement.reportProcessing')}</span>
                                    {renderReimbursementTypes()}
                                </div>
                            ) : item.model === 'Arvode' ? (
                                t('honorarium.honorarium')
                            ) : item.model === 'Betala' ? (
                                t('payReceive.pay')
                            ) : item.model === 'Intern transaktion' ? (
                                t('internalTransaction.internalTransaction')
                            ) : (
                                item.model
                            )}
                        </div>

                        <div className="col-2 text-start">{item.orgName}</div>
                        <div className="col-2 text-start">{item.createdAt ? ChangeDateFormat('dateTime', item.createdAt): ''}</div>
                        <div className="col-2 text-end">{item.instructedAmount ? ToCustomDecimal(item.instructedAmount) : 0} kr</div>
                        <div className="col-2 text-end">   
                            <button id={item.modelId} className="rounded py-2 border-0 text-green bg-green-light p-custom-button position-relative class-approve"
                                onClick={() => {
                                    navigate(item.attestId
                                        ? `${ADMIN_PATHS.ATTEST_INFO}?id=${item.attestId}&from=bankTransferHistory&paymentId=${paymentId}`
                                        : `${ADMIN_PATHS.BANK_TRANSFERS_INFO}?id=${item.modelId}&paymentId=${paymentId}&model=${item.model}&amount=${item.instructedAmount}&from=history`);
                                }} >
                                <i className="bx bx-show pb-custom align-middle size-icon-custom-button" />
                                <div className="tooltip-custom-button">
                                    {t('button.info')}
                                </div>
                            </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
    

    const contentPaymentFooterDeny = (
        <>
           
            <Button className="box-red border-0" onClick={() => {
            if (window.history.state?.modalOpen) {
                // window.history.back();
                setShowPaymentDetails(false);
            } else {
                let url = new URL(window.location.href);
                url.searchParams.delete('paymentId');
                window.history.replaceState({}, document.title, url.toString());
                setShowPaymentDetails(false);
            }
            }}>{t('button.cancel')}</Button>
        </>
    );

    return(
        <>
        <CustomModal isOpen={showPaymentDetails} toggle={() => setShowPaymentDetails(!showPaymentDetails)}  body={contentPaymentDetails} footer={contentPaymentFooterDeny} size='xl'/>
            {!isReadOnly && !isMobile && (
                <Col lg={12} className="px-0">
                    <CustomButton
                        text={t('button.back')}
                        icon={'bx bx-chevron-left'}
                        buttonSize={'small'}
                        customClasses={'mb-3 ms-3 backButton'}
                        onClick={() => {
                            navigate(ADMIN_PATHS.BANK_TRANSFERS_LIST)
                        }}
                    />
                </Col>
            )}
            <Col lg={12} className=' pb-5 px-0'>
                <Card className='card-backend p-4'>
                    <Row>
                        <Col lg={6}>
                            <h2 className="fw-bold rokkitt-font">{t('openPayment.historyBankList')}</h2>
                        </Col>
                        {isReadOnly && (
                            <Col lg={6} className="text-end">
                                <Button
                                    className="bg-green"
                                    onClick={() => {
                                        if (setActiveTab) {
                                            setActiveTab("5");
                                        } else {
                                            navigate(ADMIN_PATHS.BANK_TRANSFERS_LIST);
                                        }
                                    }}
                                >
                                    {t('openPayment.myItems')}
                                </Button>
                            </Col>
                        )}
                    </Row>
                    <SortableList
                        listOptions={listOptions}
                        setApiCallDone={setResponseOpenPaymentList}
                    />
                </Card>

            </Col>

        </>
    );
}